module.exports = __webpack_public_path__ + "files/293f1583d2d4198e43ab74026c543034.png";